import React from "react";
import { observer } from "mobx-react";
import "./GenericTab.scss";

const GenericTab = i => observer(() => <div className="activity-tab">GENERIC TAB #{i}</div>);

export default GenericTab;
